<template>
<div style="position:relative">
   <div class="ph_descr"
     v-if="descr">
     {{descr}}
   </div>

   <div class="ph_section"
     v-if="in_ph[0] || btn_send[0]">
     <input type="text"
        style="letter-spacing:0.1rem"
        v-if="in_ph[0]"
        :disabled="in_ph[1]"
        class="subinput"
        placeholder="Phone number"
        autocomplete="off"
        v-model="ph"
        v-on:keyup='ph_keyup'
        >
     </input>
     <div v-if="ph_err"
      class="ph_error">
      {{ph_err}}
     </div>
     <b-button
        v-if="btn_send[0]"
        :disabled="btn_send[1]"
        size="sm"
        class="mt-2"
        variant="primary"
        @click="sendCode"
        >
        Send Verification Code
     </b-button>
   </div>

   <div class="ph_section"
     v-if="in_vcode[0] || btn_vcode[0]">
     <input type="text"
        style="letter-spacing:0.2rem"
        v-if="in_vcode[0]"
        :disabled="in_vcode[1]"
        class="subinput"
        placeholder="Code From Message"
        maxlength="6"
        autocomplete="off"
        v-model.trim="vcode"
        v-on:keyup='vcode_keyup'
        >
     </input>
     <div v-if="val_err"
      class="ph_error"
      >
        {{val_err}}
      </div>
     <b-button
        v-if="btn_vcode[0]"
        :disabled="btn_vcode[1]"
        size="sm"
        class="mt-2"
        variant="primary"
        @click="verifyCode"
        >
        Verify
     </b-button>
   </div>
     <b-button
        v-if="btn_success[0]"
        size="sm"
        class="mt-2"
        style="width:100%"
        variant="success"
        @click="allDone"
        >
        Success
     </b-button>
     <b-button
        v-if="!btn_success[0]"
        size="sm"
        class="mt-2"
        style="width:100%"
        variant="outline-danger"
        @click="allDone"
        >
        Cancel
     </b-button>
</div>
</template>

<script>

export default {
  name: "PhoneVerify",
  props: ["kind","descr"],
  components: {
  },
  watch: {
  },
  data() {
    return  {
       state: "input",
       ph: "",
       ph_err: "",
       vcode: "",
       val_err: "",
       in_ph: [false, false],
       btn_send: [false, false],
       in_vcode: [false, false],
       btn_vcode: [false, false],
       btn_success: [false, false],
       failures: [],
    };
  },
  computed: {
  },
  mounted: function() {
    let vue = this;
    if (vue.init) {
       vue.msg = vue.init;
    }
    vue.state = "input";
    if (!vue.kind) {
      vue.in_ph = [true, true];
      vue.btn_send = [false, true];
      vue.ph_err = "Invalid kind of verification";
    } else {
      vue.in_ph = [true, false];
      vue.btn_send = [true, true];
    }
    vue.in_vcode = [false, false];
    vue.btn_vcode = [false, false];
    vue.btn_success = [false, false];
  },
  methods: {
    ph_keyup: function(ev) {
       let vue = this;
       vue.ph_err = "";
       vue.ph = vue.ph.replace(/[\(\)\-\s\D]/g,"");
       if (vue.ph.length > 0 && vue.ph[0] != "1") {
         vue.ph = "1"+vue.ph;
       }
       //if (vue.ph.length < 8 || vue.ph.length > 15) {
       // error
       //}
       if (vue.ph.length != 11) {
         vue.ph_err = "Enter a valid phone number";
         vue.btn_send = [true, true];
       } else {
         vue.btn_send = [true, false];
       }
       //console.log(vue.ph.length,""+vue.ph_err);
    },
    sendCode: function() {
      let vue = this;
      vue.state = "sendcode";
      vue.in_ph = [true, true];
      vue.btn_send = [false, true];
      vue.ph_err = "Sending verification code...";
      window.wss_send_cb(window.vx, "code_verify", {
        kind: vue.kind,
        ph: vue.ph,
      }, function(msg) {
        vue.ph_err = "";
        vue.in_vcode = [true, false];
        vue.btn_vcode = [true, true];
      });
    },
    vcode_keyup: function(ev) {
       let vue = this;
       vue.val_err = "";
       vue.vcode = vue.vcode.replace(/[\(\)\-\s\D]/g,"");
       if (!vue.vcode || vue.vcode.length < 6) {
         vue.val_err = "Enter a valid code";
         vue.btn_vcode = [true, true];
       } else if (vue.vcode.length > 6) {
         vue.vcode = vue.vcode.substring(0,6);
       } else if (vue.failures.includes(vue.vcode)) {
         vue.val_err = "You already tried that code.";
         vue.btn_vcode = [true, true];
       } else {
         vue.btn_vcode = [true, false];
       }
    },
    verifyCode: function() {
      let vue = this;
      vue.state = "verify";
      vue.in_vcode = [true, true];
      vue.btn_vcode = [false, true];
      vue.val_err = "Verifying code...";
      window.wss_send_cb(window.vx, "code_verify", {
        kind: vue.kind,
        ph: vue.ph,
        vcode: vue.vcode,
      }, function(msg) {
        if (!msg || !msg.data || !msg.data.ok) {
          vue.val_err = "The provided code is not valid.";
          if (msg && msg.data && msg.data.error && msg.data.error.code) {
             let code = msg.data.error.code;
             if (code == "expired") {
                vue.val_err = "The provided code has expired.";
                /* No point in continuing */
                return;
             } else if (code == "mismatch") {
                vue.val_err = "The provided code is incorrect.";
             }
          }
          vue.failures.push(vue.vcode);
          if (vue.failures.length > 3) {
            setTimeout(function() {
              vue.val_err = "Too many failed attempts.";
            }, 1000);
          } else {
            setTimeout(function() {
              vue.in_vcode = [true, false];
              vue.btn_vcode = [true, true];
            }, 1000);
          }
        } else {
          vue.val_err = "";
          vue.btn_success = [true,false];
        }
      });
    },
    allDone: function() {
      let vue = this;
      if (vue.btn_success[0]) {
        vue.$emit("done", {ok:true});
      } else {
        vue.$emit("done", {ok:false});
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.subinput {
  display: block;
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 5px;
  padding-left:0.5rem;
}

.ph_section {
 position: relative;
 border: solid 1px #a0a0a0;
 padding:0.2rem;
 border-radius:5px;
 margin-top:0.4rem;
 margin-bottom:0.4rem;
}

.ph_descr {
 font-size:0.8rem;
 padding-left:1rem;
 color:#0070d0;
}

.ph_error {
 font-size:0.8rem;
 font-weight: bold;
 margin-bottom: 0.2rem;
 padding-left:1rem;
 color:#e02020;
}
</style>